
const LOADING_CASE_LABELS = {
  full: '페이지를 불러오는 중입니다.',
  content: '콘텐츠를 불러오는 중입니다.',
  layout: '본문을 불러오는 중입니다.'
}

export default {
  name: 'SkeletonSpinner',
  props: {
    loadingCase: {
      type: String,
      default: 'content'
    }
  },
  computed: {
    normalizedLoadingCase () {
      return LOADING_CASE_LABELS[this.loadingCase] ? this.loadingCase : 'content'
    },
    ariaLabel () {
      return LOADING_CASE_LABELS[this.normalizedLoadingCase]
    }
  }
}
